module.exports = __webpack_public_path__ + "img/feature_xj.94d1cbda.gif";